import get from 'lodash/get';
import { createSelector } from 'reselect';

export const selectRootState = state =>
  get(state, 'paperwork.paperworkUserDetails');

export const selectPaperworkUserDataPending = createSelector(
  selectRootState,
  state => get(state, 'sending', false),
);
export const selectPaperworkUserId = createSelector(
  selectRootState,
  state => get(state, 'id', false),
);

export const selectPaperworkUserDisplayableName = createSelector(
  selectRootState,
  state => get(state, 'displayableName', ''),
);

export const selectPaperworkUserCountryName = createSelector(
  selectRootState,
  state => get(state, 'country', ''),
);

export const selectPaperworkUserSkipInsurance = createSelector(
  selectRootState,
  state => get(state, 'skipInsurance', ''),
);

export const selectPaperworkUserPrimaryPatientProfileId = createSelector(
  selectRootState,
  state => get(state, 'primaryPatientProfile.id', null),
);

export const selectPaperworkGuarantorId = createSelector(
  selectRootState,
  state => get(state, 'primaryPatientProfile.guarantorUser.id', null),
);

export const selectPaperworkGuarantor = createSelector(
  selectRootState,
  state => get(state, 'primaryPatientProfile.guarantorUser', null),
);

export const selectPaperworkUserEmergencyContactAttributes = createSelector(
  selectRootState,
  state => get(state, 'primaryPatientProfile.emergencyContactAttributes', {}),
);

export const selectPaperworkUserPrimaryPatientProfile = createSelector(
  selectRootState,
  state => get(state, 'primaryPatientProfile', {}),
);

export const selectPaperworkHasProviderProfileSelector = createSelector(
  selectRootState,
  state => get(state, 'primaryProviderProfile', {}),
);



// WEBPACK FOOTER //
// ./src/redux/paperwork/selectors/paperwork-get-user-details.js